import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import { AdminComfortTradeSenderDetails } from "@/pages/admin/comfort-trade";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_dashboard/admin/comfort-trade/senders/$senderEmail",
)({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	const { senderEmail } = Route.useParams();
	return (
		<DashboardLayout>
			<AdminComfortTradeSenderDetails senderEmail={senderEmail} />
		</DashboardLayout>
	);
}
